import { getClassNames } from '@websolutespa/bom-core';
import { useLlm } from '@websolutespa/bom-mixer-llm';
import style from './page-streaming-indicator.module.scss';

export const PageStreamingIndicator: React.FC = () => {
  const streaming = useLlm(state => state.streaming);
  const classNames = getClassNames(style.indicator, {
    [style.streaming]: streaming,
  });
  return (
    <div className={classNames}>
      <div className={style.icon}></div>
    </div>
  );
};

